<template>
  <div class="kehuset">
    <div class="inputs">
      <van-radio-group v-model="checkedValue">
        <van-radio name="46" checked-color="#FF410A">立即提醒我</van-radio>
        <van-radio name="2" checked-color="#FF410A"
          >15分钟内只提醒一次（汇总提醒）</van-radio
        >
        <van-radio name="3" checked-color="#FF410A"
          >1小时内只提醒一次（汇总提醒）</van-radio
        >
        <van-radio name="4" checked-color="#FF410A"
          >3小时内只提醒一次（汇总提醒）</van-radio
        >
        <van-radio name="5" checked-color="#FF410A"
          >关闭谁看我提醒（不会收到消息提醒）</van-radio
        >
      </van-radio-group>
    </div>
    <div class="inputs">
      <div class="inputli2">
        <span>自己看自己的不提醒</span>
        <van-switch
          v-model="checked1"
          active-color="#FF410A"
          inactive-color="#f5f5f5"
        />
      </div>
    </div>
    <div class="inputs">
      <div class="inputli2">
        <span>夜间勿扰<i>(北京时间23:00-6:00)</i></span>
        <van-switch
          v-model="checked2"
          active-color="#FF410A"
          inactive-color="#f5f5f5"
        />
      </div>
    </div>
  </div>
</template>

<script>
import "@assets/css/kehu.css";
import { createApp } from "vue";
import { Toast, RadioGroup, Radio, Switch } from "vant";
import { getShare } from "@api/public";
import { cookie } from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
let vm = null;
export default {
  name: "setMessageReminder",
  components: {
    [Switch.name]: Switch,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio
  },
  props: {},
  data: function() {
    return {
      checkedValue: "46",
      checked1: true,
      checked2: true
    };
  },
  created() {
    vm = this;
  },
  watch: {},
  mounted: function() {},
  methods: {
    // radioValue(e) {
    //   console.log(e);
    // },

    setOpenShare() {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>

<style>
.van-radio {
  padding: 0.2rem 0;
}
</style>
